import { Loader } from '@googlemaps/js-api-loader';

let loadedLanguage = null;

function getLoader(language) {
  if (Loader.instance && loadedLanguage === language) return Loader.instance;

  if (Loader.instance) {
    Loader.instance.deleteScript();
    Loader.instance = null;
    if (window.google) delete window.google;
  }

  loadedLanguage = language;
  return new Loader({
    apiKey: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    version: 'weekly',
    language,
    region: 'GR',
  });
}

export async function importLibrary(name, language = 'el') {
  return getLoader(language).importLibrary(name);
}
